import styled from 'styled-components'

export const Header = styled.div`
  margin: 24px;
  display: flex;
  height: 3rem;
  justify-content: space-between;
  align-items: center;
`

export const LeftSideLogoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex: 0 1 180px;
`

export const CenterBannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 0 0 auto;
  padding: 0 12px;
`

export const RightSideButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 0 1 180px;
`

export const FullWidthBannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 1 1 100%;
`
